module.exports = __webpack_public_path__ + "static/media/wash.c1d825c3.png";